module.exports = __webpack_public_path__ + "media/images/symbol-defs-d06ff8338e5153fede38cab5d3a4e0b4.svg";